<div class="app-button-spinner-pos-absolute">
  <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
</div>
